import * as React from 'react'

import {
  Box,
  Typography,
  Button
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux';
import ApiKeyModal from '../../modals/admin/ApiKeyModal';
import { getKey, setKey } from '../../slices/utils';

export default function KeySection(props) {
  const defaultKey = useSelector(state => state.utils.key);
  const [openKeyModal, setOpenKeyModal] = React.useState(false);
  const dispatch = useDispatch();
  
  React.useEffect(() => {
    if(defaultKey === '')
      dispatch(getKey())
  }, [])

  const handleSave = (data) => {
    let info = new FormData();
    info.append('key', data);
    dispatch(setKey(info))
    .then(res => {    
      setOpenKeyModal(false);
    })
    .catch(err => console.log(err))
  }

  const handleClose = (e) => {
    setOpenKeyModal(false);
  }
  return (
    <Box className='w-full h-full flex flex-column'>
      <Box className='w-full section-title-height'>
        <Box className='w-full flex flex-row'>
          <Typography 
            sx={{ 
              fontSize: 16, 
              fontWeight: 400, 
              padding: 2,
            }}
            className='flex-basis'
          >
            Default API Key
          </Typography>
          <Button 
            variant='contained' 
            sx={{ 
              margin: 2, 
              color: 'white', 
              background: '#7354EF',
              textTransform: 'none'
            }}
            onClick={() => setOpenKeyModal(true)}
          >
            Change API Key
          </Button>
        </Box>
      </Box>
      <ApiKeyModal open={openKeyModal} value={defaultKey} handleClose={handleClose} handleSave={handleSave} />
    </Box>
  )
}